import type { Mission } from '../missions.ts'

export const fhwa: Mission = {
  id: "fhwa",
  name: "Federal Highway Administration",
  short: "FHWA",
  call: "Highways",
  kind: "subagency",
  parent: "dot",
  url: "https://highways.dot.gov/",
  established: 1966,
  palette: {
    primary: "#194178",
    secondary: "#0079c0",
    accent: "#a8cf45",
  },
  colorSource: {
    kind: "site",
    url: "https://highways.dot.gov/",
  },
  motif: "road",
  mission: {
    text: "Improve safety and mobility on our nation’s highways through national leadership, innovation, and program delivery.",
    url: "https://highways.dot.gov/about/about-fhwa",
  },
  fact: {
    text: "FHWA traces its roots to the Office of Road Inquiry, founded in 1893.",
    url: "https://highways.dot.gov/about/about-fhwa",
  },
  logo: {
    file: "public/logos/fhwa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_Federal_Highway_Administration.svg",
  },
  identifier: {
    about: "https://highways.dot.gov/about/about-fhwa",
    accessibility: "https://highways.dot.gov/section-508/our-commitment",
    foia: "https://highways.dot.gov/foia",
    noFear: "https://www.transportation.gov/civil-rights/civil-rights-awareness-enforcement/no-fear-act",
    oig: "https://www.oig.dot.gov/",
    performance: "https://www.transportation.gov/budget/dot-budget-and-performance",
    privacy: "https://www.transportation.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/fhwa-hoover-bypass.jpg",
        small: "/media/fhwa-hoover-bypass-sm.jpg",
        alt: "Aerial view of the concrete arch of the Hoover Dam Bypass Bridge spanning the Black Canyon, with Hoover Dam and Lake Mead beyond.",
        title: "Hoover Dam Bypass Bridge under construction, October 12, 2010",
        creator: "Federal Highway Administration",
        source: "https://commons.wikimedia.org/wiki/File:Hoover_Dam_Bypass_Bridge,_Hoover_Dam,_Lake_Mead_2010-10-12.jpg",
        license: "CC BY 2.0",
      },
      {
        file: "/media/fhwa-linn-cove.jpg",
        small: "/media/fhwa-linn-cove-sm.jpg",
        alt: "Aerial view of the S-curved Linn Cove Viaduct hugging the side of Grandfather Mountain amid trees turning orange and red.",
        title: "Linn Cove Viaduct, Blue Ridge Parkway, North Carolina, 2024",
        creator: "National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Inspections_revealed_that_the_Linn_Cove_Viaduct_was_undamaged_by_Hurricane_Helene._This_photo_was_taken_by_licensed_pilots_(633e8fa8-da78-4dba-b326-cde972ae1e7f).JPG",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
